export default "__VITE_ASSET__dcb9198a__"